import { Link, useLocation } from 'react-router-dom';
import { FiArrowUpRight, FiMenu, FiX } from 'react-icons/fi';
import { useState } from 'react';

const Layout = ({ children }) => {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const links = [
    { to: '/', label: 'Главная' },
    { to: '/sveden', label: 'Сведения об ОО' },
    { to: '/photo', label: 'Фотогалерея' },
    { to: '/contacts', label: 'Контакты' }
  ];

  return (
    <div className="site-shell">
      <header className="site-header">
        <div className="container site-header__inner">
          <Link to="/" className="brand" onClick={() => setMenuOpen(false)}>
            <span className="brand__mark">#</span>
            <span><strong>БезПробелов</strong><small>центр знаний</small></span>
          </Link>
          <button className="menu-toggle" onClick={() => setMenuOpen(!menuOpen)} aria-label="Открыть меню">
            {menuOpen ? <FiX /> : <FiMenu />}
          </button>
          <nav className={`main-nav ${menuOpen ? 'main-nav--open' : ''}`}>
            {links.map((link) => (
              <Link key={link.to} to={link.to} onClick={() => setMenuOpen(false)} className={location.pathname === link.to ? 'is-active' : ''}>
                {link.label}
              </Link>
            ))}
          </nav>
          <Link to="/contacts" className="header-cta">Связаться <FiArrowUpRight /></Link>
        </div>
      </header>
      <main className="site-main">{children}</main>
      <footer className="site-footer">
        <div className="container footer-grid">
          <div><Link to="/" className="brand brand--footer"><span className="brand__mark">#</span><span><strong>БезПробелов</strong><small>центр знаний</small></span></Link><p>Знания, которые открывают<br />новые возможности.</p></div>
          <div className="footer-meta"><span>Калуга · с 2016 года</span><span>© {new Date().getFullYear()} Все права защищены</span></div>
        </div>
      </footer>
    </div>
  );
};

export default Layout;
